import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/common.css'
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
import store from '@/store'
// import Vconsole from 'vconsole'; //手机端调试

import VueI18n from 'vue-i18n'
//font
import "./assets/font/iconfont.css"

Vue.use(VueI18n)
// new Vconsole(); //手机端调试
Vue.config.ignoredElements.push('wx-open-launch-weapp')

Vue.config.productionTip = false;
NutUI.install(Vue);

const i18n = new VueI18n({
    locale: 'en', // 语言标识
    messages: {
        'en': require('./assets/lang/en'), // 英文语言包
        'es': require('./assets/lang/es'), // 西班牙语言包
        'de': require('./assets/lang/de'), // 德国语言包
        'it': require('./assets/lang/it'), // 意大利语言包
        'fr': require('./assets/lang/fr'), // 法国语言包
        'rb': require('./assets/lang/rb'), // 日本语言包
        'tha': require('./assets/lang/tha'), // 泰国语言包
        'phl': require('./assets/lang/phl'), // 菲律宾语言包
    }
});
new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app')
router.afterEach((to,from,next) => {
    document.querySelector("body").setAttribute("style","overflow: auto !important;")
})